module.exports = __webpack_public_path__ + "img/Cepat@2x.6d519439.png";